/**
 * Universal PDP — extras for product details (subscription modal trigger, LCP observer).
 * Product gallery lives in pdp-hero-gallery.js + snippets/pdp-hero-gallery.liquid.
 */

document.addEventListener('DOMContentLoaded', function() {
  initializePerformanceMonitoring();
  initializeSubscriptionBonusTrigger();
});

function initializePerformanceMonitoring() {
  if ('PerformanceObserver' in window) {
    try {
      var lcpObserver = new PerformanceObserver(function() {});
      lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
    } catch (e) {}
  }
}

function initializeSubscriptionBonusTrigger() {
  var subscriptionMoreText = document.querySelector('.pdp-details__subscription-more-text');
  if (subscriptionMoreText) {
    subscriptionMoreText.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      if (typeof window.openSubscriptionBonusesModal === 'function') {
        window.openSubscriptionBonusesModal();
      }
    });
  }
}
